import { percentile } from "./reports";

export const PROVIDERS = ["Vodacom", "MTN", "Cell C", "Telkom", "Rain"];
const MATCH = [[/vodacom/i, "Vodacom"], [/\bmtn\b/i, "MTN"], [/cell\s?c/i, "Cell C"], [/telkom|8ta/i, "Telkom"], [/\brain\b/i, "Rain"]];

export const canonicalProvider = (isp) => MATCH.find(([re]) => re.test(isp || ""))?.[1] || null;

const SPEED_CAP = 50;

export const scoreGroup = (ts) => {
  if (!ts.length) return null;
  const dl = percentile(ts.map((t) => t.download_mbps), 50);
  const reliability = (ts.filter((t) => !t.issues.length).length / ts.length) * 100;
  const speedScore = Math.min(dl / SPEED_CAP, 1) * 100;
  return {
    n: ts.length, dl, reliability,
    ul: percentile(ts.map((t) => t.upload_mbps), 50),
    ping: percentile(ts.map((t) => t.ping_ms), 50),
    score: Math.round(speedScore * 0.5 + reliability * 0.5),
  };
};

export const scorecard = (tests) => {
  const by = {};
  tests.forEach((t) => {
    const p = canonicalProvider(t.isp);
    if (!p) return;
    ((by[t.team] ||= {})[p] ||= []).push(t);
    ((by.__all ||= {})[p] ||= []).push(t);
  });
  const national = PROVIDERS.map((p) => ({ provider: p, ...scoreGroup(by.__all?.[p] || []) }))
    .filter((r) => r.n).sort((a, b) => b.score - a.score);
  const provinces = Object.keys(by).filter((k) => k !== "__all").sort().map((prov) => {
    const cells = Object.fromEntries(PROVIDERS.map((p) => [p, scoreGroup(by[prov][p] || [])]));
    const best = PROVIDERS.filter((p) => cells[p]).sort((a, b) => cells[b].score - cells[a].score)[0];
    return { province: prov, cells, best };
  });
  return { national, provinces };
};
